import React, { useEffect, useState } from 'react'

const DieselIFrame = ({showId}) => {
    const [currentHeight, setCurrentHeight] = useState(1020)
    // const message = { type: "heightChanged", payload: 1652 }
    useEffect(() => {
        window.addEventListener('message', (event) => {
            if(event.data && event.data.type === "heightChanged") {
                if(event.data.payload && event.data.payload !== currentHeight) {
                    setCurrentHeight(event.data.payload)
                }
            }
        })
    
        return () => {
            window.removeEventListener('message', (event) => {
                if(event.data && event.data.type === "heightChanged") {
                    if(event.data.payload && event.data.payload !== currentHeight) {
                        setCurrentHeight(event.data.payload)
                    }
                }
            })
        }
    })

    const style = {        
        minHeight: currentHeight + 'px'
    }

    return (
        <div id="diesel-iframe" className='theme-radius-posters-full'>
            <iframe style={style} src={`https://kinoapi.dieselkino.at/?performanceId=${showId}`}/>
            {/* <div> */}
                {/* <div is="soft-seat-reservation"></div> */}
                {/* <soft-seat-reservation cinema-hall-id={showId}></soft-seat-reservation> */}
            {/* </div> */}
        </div>
    )  
}
// customElements.define("soft-seat-reservation", DieselIFrameWebComponent, { extends: "div" });

export default DieselIFrame